import {
  Store,
  Globe,
  Bike,
  Cpu,
  ClipboardList,
  TrendingUp,
} from "lucide-react";

/* Icon + category label + accent color for every service slug. Shared by the
   Hizmetlerimiz overview and by every /hizmetlerimiz/:slug detail page. */
export const SERVICE_META = {
  "pazaryeri-kurulum-yonetimi": {
    Icon: Store,
    category: "SATIŞ KANALI",
    accent: "#00F22E",
  },
  "uye-isyerine-ozel-siparis-sistemi": {
    Icon: Globe,
    category: "KENDİ KANALINIZ",
    accent: "#00E560",
  },
  "kurye-cozumu": {
    Icon: Bike,
    category: "TESLİMAT",
    accent: "#4BFF7A",
  },
  "fiyat-ve-stok-entegrasyonu": {
    Icon: Cpu,
    category: "ENTEGRASYON",
    accent: "#00F22E",
  },
  "urun-ve-menu-yonetimi": {
    Icon: ClipboardList,
    category: "ÜRÜN & MENÜ",
    accent: "#7BFF9E",
  },
  "dijital-operasyon-yonetimi": {
    Icon: TrendingUp,
    category: "OPERASYON",
    accent: "#00F22E",
  },
};

/* Per-service miniature UI illustration. `size = "sm"` for grid cards,
   `size = "lg"` for the detail-page hero visual. */
export function ServiceIllustration({ slug, size = "sm" }) {
  const heightClass = size === "lg" ? "h-40 md:h-56" : "h-14";
  const common = `w-full ${heightClass} mt-4 opacity-90`;
  switch (slug) {
    case "pazaryeri-kurulum-yonetimi":
      return (
        <svg className={common} viewBox="0 0 200 56" fill="none" aria-hidden="true" preserveAspectRatio="xMidYMid meet">
          {[0, 1, 2, 3].map((i) => (
            <g key={i} transform={`translate(${i * 46}, 6)`}>
              <rect width="40" height="44" rx="6" fill="rgba(255,255,255,0.04)" stroke="rgba(0,242,46,0.28)" />
              <rect x="6" y="8" width="28" height="4" rx="2" fill="rgba(0,242,46,0.65)" />
              <rect x="6" y="18" width="20" height="3" rx="1.5" fill="rgba(255,255,255,0.35)" />
              <rect x="6" y="26" width="24" height="3" rx="1.5" fill="rgba(255,255,255,0.22)" />
              <rect x="6" y="34" width="14" height="3" rx="1.5" fill="rgba(255,255,255,0.15)" />
            </g>
          ))}
        </svg>
      );
    case "uye-isyerine-ozel-siparis-sistemi":
      return (
        <svg className={common} viewBox="0 0 200 56" fill="none" aria-hidden="true" preserveAspectRatio="xMidYMid meet">
          <rect x="10" y="6" width="110" height="40" rx="4" fill="rgba(255,255,255,0.04)" stroke="rgba(0,242,46,0.28)" />
          <rect x="18" y="14" width="60" height="5" rx="2" fill="rgba(0,242,46,0.6)" />
          <rect x="18" y="24" width="90" height="3" rx="1.5" fill="rgba(255,255,255,0.28)" />
          <rect x="18" y="32" width="70" height="3" rx="1.5" fill="rgba(255,255,255,0.18)" />
          <line x1="55" y1="46" x2="75" y2="46" stroke="rgba(255,255,255,0.35)" strokeWidth="2" />
          <rect x="140" y="4" width="34" height="48" rx="6" fill="rgba(255,255,255,0.04)" stroke="rgba(0,242,46,0.4)" />
          <rect x="146" y="12" width="22" height="4" rx="2" fill="rgba(0,242,46,0.75)" />
          <rect x="146" y="20" width="22" height="3" rx="1.5" fill="rgba(255,255,255,0.3)" />
          <rect x="146" y="27" width="18" height="3" rx="1.5" fill="rgba(255,255,255,0.2)" />
          <circle cx="157" cy="43" r="3" fill="rgba(0,242,46,0.7)" />
        </svg>
      );
    case "kurye-cozumu":
      return (
        <svg className={common} viewBox="0 0 200 56" fill="none" aria-hidden="true" preserveAspectRatio="xMidYMid meet">
          <path
            d="M14 44 C 50 44, 60 18, 100 20 S 160 44, 186 20"
            stroke="rgba(0,242,46,0.55)"
            strokeWidth="1.5"
            fill="none"
            strokeDasharray="3 3"
          />
          <circle cx="14" cy="44" r="5" fill="rgba(0,242,46,0.85)" />
          <circle cx="14" cy="44" r="10" stroke="rgba(0,242,46,0.25)" fill="none" />
          <path d="M186 20 l -4 -8 h 8 z" fill="rgba(0,242,46,0.9)" />
          <rect x="182" y="4" width="8" height="10" rx="1" fill="rgba(0,242,46,0.9)" />
          <circle cx="90" cy="22" r="3" fill="rgba(255,255,255,0.55)" />
        </svg>
      );
    case "fiyat-ve-stok-entegrasyonu":
      return (
        <svg className={common} viewBox="0 0 200 56" fill="none" aria-hidden="true" preserveAspectRatio="xMidYMid meet">
          <rect x="10" y="10" width="46" height="36" rx="4" fill="rgba(255,255,255,0.04)" stroke="rgba(0,242,46,0.3)" />
          <rect x="16" y="16" width="34" height="3" rx="1.5" fill="rgba(0,242,46,0.6)" />
          <rect x="16" y="23" width="28" height="3" rx="1.5" fill="rgba(255,255,255,0.25)" />
          <rect x="16" y="30" width="22" height="3" rx="1.5" fill="rgba(255,255,255,0.2)" />
          <rect x="144" y="10" width="46" height="36" rx="4" fill="rgba(255,255,255,0.04)" stroke="rgba(0,242,46,0.3)" />
          <rect x="150" y="16" width="34" height="3" rx="1.5" fill="rgba(0,242,46,0.6)" />
          <rect x="150" y="23" width="28" height="3" rx="1.5" fill="rgba(255,255,255,0.25)" />
          <rect x="150" y="30" width="22" height="3" rx="1.5" fill="rgba(255,255,255,0.2)" />
          <line x1="60" y1="22" x2="140" y2="22" stroke="rgba(0,242,46,0.6)" strokeWidth="1.5" />
          <line x1="140" y1="34" x2="60" y2="34" stroke="rgba(0,242,46,0.4)" strokeWidth="1.5" strokeDasharray="3 2" />
          <path d="M136 22 l -6 -3 v 6 z" fill="rgba(0,242,46,0.9)" />
          <path d="M64 34 l 6 -3 v 6 z" fill="rgba(0,242,46,0.7)" />
        </svg>
      );
    case "urun-ve-menu-yonetimi":
      return (
        <svg className={common} viewBox="0 0 200 56" fill="none" aria-hidden="true" preserveAspectRatio="xMidYMid meet">
          {[0, 1, 2, 3].map((i) => (
            <g key={i} transform={`translate(10, ${i * 12 + 4})`}>
              <rect width="10" height="10" rx="2" fill="rgba(0,242,46,0.15)" stroke="rgba(0,242,46,0.55)" />
              <path
                d="M2 5 l 3 3 l 5 -5"
                stroke={i < 3 ? "#00F22E" : "rgba(255,255,255,0.3)"}
                strokeWidth="1.5"
                fill="none"
              />
              <rect x="18" y="3" width={110 - i * 8} height="4" rx="2" fill="rgba(255,255,255,0.35)" />
            </g>
          ))}
        </svg>
      );
    case "dijital-operasyon-yonetimi":
      return (
        <svg className={common} viewBox="0 0 200 56" fill="none" aria-hidden="true" preserveAspectRatio="xMidYMid meet">
          {[
            [10, 40, 12],
            [30, 32, 20],
            [50, 26, 26],
            [70, 20, 32],
            [90, 14, 38],
          ].map(([x, y, h], i) => (
            <rect
              key={i}
              x={x}
              y={y}
              width="10"
              height={h}
              rx="2"
              fill={i === 4 ? "rgba(0,242,46,0.9)" : "rgba(0,242,46,0.35)"}
            />
          ))}
          <path
            d="M15 40 L 35 34 L 55 28 L 75 22 L 95 16 L 130 12"
            stroke="rgba(0,242,46,0.85)"
            strokeWidth="1.5"
            fill="none"
          />
          <circle cx="130" cy="12" r="3" fill="#00F22E" />
          <rect x="150" y="8" width="40" height="40" rx="4" fill="rgba(255,255,255,0.04)" stroke="rgba(0,242,46,0.28)" />
          <rect x="156" y="14" width="26" height="4" rx="2" fill="rgba(0,242,46,0.6)" />
          <rect x="156" y="24" width="22" height="3" rx="1.5" fill="rgba(255,255,255,0.35)" />
          <rect x="156" y="32" width="18" height="3" rx="1.5" fill="rgba(255,255,255,0.22)" />
        </svg>
      );
    default:
      return null;
  }
}
